import { Button, ModalContentWrapper } from 'ui';

interface NewHolderOnboardedModalProps {
  open: boolean;
  onViewHolders: () => void | Promise<void>;
  isLoading?: boolean;
}

export function NewHolderOnboardedModal({
  open,
  onViewHolders,
  isLoading = false,
}: NewHolderOnboardedModalProps) {
  return (
    <ModalContentWrapper
      open={open}
      title="New holder awaiting review"
      onClose={onViewHolders}
      variant="center"
      persistOnNavigate
      classes={{ dialogPanel: 'max-w-lg' }}
    >
      <div className="flex flex-col gap-6 px-6 pb-6 pt-2">
        <p className="text-sm text-gray-500">
          A new holder has completed onboarding and is waiting for an issuer admin to approve or
          decline the request.
        </p>

        <div className="flex justify-end">
          <Button onClick={onViewHolders} loading={isLoading}>
            Go to holders
          </Button>
        </div>
      </div>
    </ModalContentWrapper>
  );
}
